import { render, staticRenderFns } from "./mobile_demand_info.vue?vue&type=template&id=4aebd41c&scoped=true&"
import script from "./mobile_demand_info.vue?vue&type=script&lang=js&"
export * from "./mobile_demand_info.vue?vue&type=script&lang=js&"
import style0 from "./mobile_demand_info.vue?vue&type=style&index=0&id=4aebd41c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aebd41c",
  null
  
)

export default component.exports